import React from 'react';
import { JuniorLayout } from '../../components/layout/JuniorLayout';
import { ActivityShell } from '../../components/activity/ActivityShell';
import { RequireJuniorSession } from '../../components/auth/RequireJuniorSession';
import { BoomJuniorShell } from '../../components/boom/BoomJuniorShell';
import { RhythmApp } from '../../boom/apps/RhythmApp';
import { useJuniorAliveNav } from '../../contexts/JuniorAliveNavContext';
import {
  PresentationModeProvider,
  usePresentationMode,
} from '../../contexts/PresentationModeContext';

function BoomPracticaRitmosPageInner() {
  const { navigateAlive } = useJuniorAliveNav();
  const { isPresentation } = usePresentationMode();

  return (
    <JuniorLayout immersive presentation={isPresentation}>
      <ActivityShell
        title="Práctica de ritmos"
        subtitle="Figuras rítmicas por tiempo"
        backTo="/ritmo"
        backLabel="Ritmo"
        immersive
        lockViewport
        fullBleed
        presentation={isPresentation}
      >
        <BoomJuniorShell>
          <RhythmApp onBack={() => navigateAlive('/ritmo')} />
        </BoomJuniorShell>
      </ActivityShell>
    </JuniorLayout>
  );
}

export default function BoomPracticaRitmosPage() {
  return (
    <RequireJuniorSession>
      <PresentationModeProvider>
        <BoomPracticaRitmosPageInner />
      </PresentationModeProvider>
    </RequireJuniorSession>
  );
}
